module.exports = "<div class=\"app {{ customClasses }}\">\n  <div class=\"app-container\">\n    <div *ngIf=\"sidebarEnabled\" class=\"sidebar-container\">\n      <sidebar [expanded]=\"expandedSidebar\"></sidebar>\n    </div>\n\n    <div class=\"main-component-container\" [ngClass]=\"{expanded: expandedSidebar}\">\n      <toolbar *ngIf=\"toolbarEnabled\" class=\"toolbar\">\n        <ng-container left-first>\n          <div>&nbsp;</div>\n        </ng-container>\n      </toolbar>\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main